/* eslint-disable react-hooks/exhaustive-deps */
import React from "react";
import Typography from "@mui/material/Typography";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import { TableHeadComponent } from "../../common/TableHead";
import Switch from "@mui/material/Switch";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import { Autocomplete, TextField } from "@mui/material";
import { switchCreator } from "./EditCameraUtils/switchCreator";
import { OrangeTextButton } from "../../common/OrangeTextButton";
import { handleProductMasterSwitchEvent } from "./EditCameraUtils/handleProductMasterSwitchEvent";
import { Dispatcher } from "../Sites/SiteAboutPage/SiteAboutPageUtils/siteAboutInterfaces";
import { handleCheckForDisabledProducts } from "./EditCameraUtils/handleCheckForDisabledProducts";
import { handleCreateSelectedProducts } from "./EditCameraUtils/handleCreateSelectedProducts";
import Tooltip from "@mui/material/Tooltip";
import { createIntruderToggle } from "./EditCameraUtils/createIntruderToggle";
import { trioMutualExclusionRecoveryMode } from "./EditCameraUtils/trioMutualExclusionRecoveryMode";
import { useEditCameraStore } from "./editCameraStore/editCameraStore";
import { AddHealthMonitoringDialog } from "./AddHealthMonitoringDialog";
import { useFeatureFlag } from "../../../hooks/useFeatureFlag";
import {
  DOUBLE_TAKE_COLUMN_TITLE,
  getDoubleTakeDisabledReason,
  isDoubleTakeVisible,
  setMetricDoubleTake,
} from "./EditCameraUtils/doubleTake";

export const ProductsTabEditMode = ({
  activeProducts,
  setPatchObject,
  setGeneralInfoChangesMade,
  cameraGeneralInfo,
  productsData,
  setProductsData,
  allTabsOpen,
  setAllTabsOpen,
  setBackupProductsData,
  siteInfo,
}: {
  activeProducts: any;
  setPatchObject: any;
  setGeneralInfoChangesMade: any;
  cameraGeneralInfo: any;
  productsData: any;
  setProductsData: Dispatcher<any>;
  allTabsOpen: boolean;
  setAllTabsOpen: Dispatcher<boolean>;
  setBackupProductsData: any;
  siteInfo: any;
}) => {
  const handlePatchThresh = (
    value: any,
    groupLabelName: string,
    object: any,
    optionNames: any
  ) => {
    const resolvedOptionId =
      value === null || value === undefined || value === ""
        ? null
        : optionNames.get(value);

    setLocalProductsData((previousState: any) => {
      const updatedProducts = [...previousState];
      const productIndex = updatedProducts.findIndex(
        (product: any) => product.label_name === groupLabelName
      );
      const updatedProduct = updatedProducts[productIndex];
      updatedProduct.metrics[object.label_name].option_id = resolvedOptionId;
      updatedProducts[productIndex] = updatedProduct;
      return updatedProducts;
    });
    setProductsData((previousState: any) => {
      const updatedProducts = [...previousState];
      const productIndex = updatedProducts.findIndex(
        (product: any) => product.label_name === groupLabelName
      );
      const updatedProduct = updatedProducts[productIndex];
      updatedProduct.metrics[object.label_name].option_id = resolvedOptionId;
      updatedProducts[productIndex] = updatedProduct;
      return updatedProducts;
    });
  };

  const handlePatchDistance = (
    value: any,
    groupLabelName: string,
    object: any,
    optionNames: any
  ) => {
    setLocalProductsData((previousState: any) => {
      const updatedProducts = [...previousState];
      const productIndex = updatedProducts.findIndex(
        (product: any) => product.label_name === groupLabelName
      );
      const updatedProduct = updatedProducts[productIndex];
      updatedProduct.metrics[object.label_name].distance =
        optionNames.get(value);
      updatedProducts[productIndex] = updatedProduct;
      return updatedProducts;
    });
    setProductsData((previousState: any) => {
      const updatedProducts = [...previousState];
      const productIndex = updatedProducts.findIndex(
        (product: any) => product.label_name === groupLabelName
      );
      const updatedProduct = updatedProducts[productIndex];
      updatedProduct.metrics[object.label_name].distance =
        optionNames.get(value);
      updatedProducts[productIndex] = updatedProduct;
      return updatedProducts;
    });
  };

  const handleExtraFieldInput = (
    value: any,
    groupLabelName: string,
    object: any
  ) => {
    setLocalProductsData((previousState: any) => {
      const updatedProducts = [...previousState];
      const productIndex = updatedProducts.findIndex(
        (product: any) => product.label_name === groupLabelName
      );
      const updatedProduct = updatedProducts[productIndex];
      updatedProduct.metrics[object.label_name].user_input_value = value;
      updatedProducts[productIndex] = updatedProduct;
      return updatedProducts;
    });
    setProductsData((previousState: any) => {
      const updatedProducts = [...previousState];
      const productIndex = updatedProducts.findIndex(
        (product: any) => product.label_name === groupLabelName
      );
      const updatedProduct = updatedProducts[productIndex];
      updatedProduct.metrics[object.label_name].user_input_value = value;
      updatedProducts[productIndex] = updatedProduct;
      return updatedProducts;
    });
  };

  const [tabsOpen, setTabsOpen] = React.useState(allTabsOpen);

  const [localProductsData, setLocalProductsData] =
    React.useState(productsData);

  const [selectedGroups, setSelectedGroups] = React.useState<any>({
    intruder: {
      selected: false,
      disabled: false,
      intruder: false,
      bike: false,
      vehicle: false,
    },
    intruderPlus: {
      selected: false,
      disabled: false,
      intruder_plus: false,
      bike_plus: false,
      vehicle_plus: false,
    },
    motionPlus: {
      selected: false,
      intruder_motion: false,
      vehicle_motion: false,
      bike_motion: false,
    },
    gun: {
      selected: false,
      gun: false,
      pistol: false,
    },
    crowd: {
      selected: false,
      crowd: false,
    },
    loitering: {
      selected: false,
      loiterer: false,
      vehicle_loiterer: false,
    },
    fallPerson: {
      selected: false,
      fall_person: false,
    },
    noHardHat: {
      selected: false,
      no_hard_hat: false,
    },
    mask: {
      selected: false,
      mask: false,
      mask_compliance: false,
      no_mask: false,
    },
    socialDistancing: {
      selected: false,
      social_distancing: false,
    },
    leftObject: {
      selected: false,
      left_object: false,
    },
    package: {
      selected: false,
      package: false,
    },
    fire: {
      selected: false,
      fire: false,
      smoke: false,
    },
    lineCrossing: {
      selected: false,
      intruder_line_crossing: false,
      vehicle_line_crossing: false,
    },
    peopleFlow: {
      selected: false,
      people_flow: false,
    },
    fall: {
      selected: false,
      fall: false,
    },
    vehicleLogoId: {
      selected: false,
      amazon: false,
      dhl: false,
      fedex: false,
      school_bus: false,
      ups: false,
      usps: false,
      envera: false,
      fire_truck: false,
    },
    nonUps: {
      selected: false,
      non_ups: false,
    },
  });

  const [updatingSelectedGroups, setUpdatingSelectedGroups] =
    React.useState(true);

  const { flags, isFeatureEnabled } = useFeatureFlag();
  const showLineCrossings = isFeatureEnabled("showLineCrossings", true);
  const allowConcurrentLineCrossingIntruderProducts = isFeatureEnabled(
    "allowConcurrentLineCrossingIntruderProducts",
    false
  );

  React.useEffect(() => {
    if (productsData.length !== 0) {
      handleCheckForDisabledProducts(
        productsData,
        setSelectedGroups,
        allowConcurrentLineCrossingIntruderProducts
      );
    }
    handleCreateSelectedProducts(
      productsData,
      setSelectedGroups,
      selectedGroups,
      setUpdatingSelectedGroups
    );
  }, []);

  const {
    chmActive,
    setChmActive,
    setAddHealthMonitoringDialogOpen,
    siteInfoEditCamera,
    vCHOnlySite,
    setCHMValueChanged,
    addHealthMonitoringDialogOpen,
    setCHMStreamMetric,
    chmStreamMetric,
    showHealthMonitoring,
  } = useEditCameraStore();

  const isAutopatrolSite =
    siteInfoEditCamera.integration_type_name === "autopatrol";
  // DoubleTake column: same gate as the Alerts-page filters (ENG-1306). The
  // toggle is staged on productsData and rides the per-metric PATCH on save.
  const showDoubleTake = isDoubleTakeVisible(flags, siteInfoEditCamera);
  const doubleTakeHeader = showDoubleTake ? [DOUBLE_TAKE_COLUMN_TITLE] : [];

  const handleToggleDoubleTake = (
    groupLabelName: string,
    metricLabelName: string,
    vlmEnabled: boolean
  ) => {
    setLocalProductsData((previousState: any) =>
      setMetricDoubleTake(
        previousState,
        groupLabelName,
        metricLabelName,
        vlmEnabled
      )
    );
    setProductsData((previousState: any) =>
      setMetricDoubleTake(
        previousState,
        groupLabelName,
        metricLabelName,
        vlmEnabled
      )
    );
    setGeneralInfoChangesMade(true);
  };
  const useAutopatrolControlledSensitivity = isAutopatrolSite && !vCHOnlySite;

  const filteredAPProductsData = localProductsData.filter((object: any) =>
    ["Intruder", "Crowd", "Fire", "Vehicle Logo ID", "Non-UPS"].includes(
      object.name
    )
  );

  const productsToExclude = ["Social Distancing", "Fall Person"];
  if (!showLineCrossings) {
    productsToExclude.push("Line Crossing");
  }

  const filteredProductsData = isAutopatrolSite
    ? filteredAPProductsData
    : localProductsData.filter(
        (object: any) => !productsToExclude.includes(object.name)
      );

  const isIntruderEnabled = selectedGroups.intruder.selected;
  const isMotionPlusEnabled = selectedGroups.motionPlus.selected;
  const isLineCrossingEnabled = selectedGroups.lineCrossing.selected;

  const productConflictRecoveryMode = trioMutualExclusionRecoveryMode(
    selectedGroups,
    allowConcurrentLineCrossingIntruderProducts
  );
  const trioActiveCount =
    Number(isIntruderEnabled) +
    Number(isMotionPlusEnabled) +
    Number(isLineCrossingEnabled);

  const motionPlusLockedAsThirdWhenTwoOn =
    !allowConcurrentLineCrossingIntruderProducts &&
    trioActiveCount === 2 &&
    !isMotionPlusEnabled;
  const lineCrossingLockedAsThirdWhenTwoOn =
    !allowConcurrentLineCrossingIntruderProducts &&
    trioActiveCount === 2 &&
    !isLineCrossingEnabled;

  const motionPlusBlockedByIntruder =
    selectedGroups.intruderPlus.disabled || isIntruderEnabled;
  const motionPlusBlockedByLineCrossing =
    !allowConcurrentLineCrossingIntruderProducts && isLineCrossingEnabled;
  const isMotionPlusToggleDisabled = allowConcurrentLineCrossingIntruderProducts
    ? isIntruderEnabled && !isMotionPlusEnabled && !productConflictRecoveryMode
    : motionPlusLockedAsThirdWhenTwoOn ||
      (!productConflictRecoveryMode &&
        (motionPlusBlockedByIntruder || motionPlusBlockedByLineCrossing));

  const lineCrossingBlockedByIntruder =
    !allowConcurrentLineCrossingIntruderProducts && isIntruderEnabled;
  const lineCrossingBlockedByMotionPlus =
    !allowConcurrentLineCrossingIntruderProducts && isMotionPlusEnabled;
  const isLineCrossingToggleDisabled =
    !allowConcurrentLineCrossingIntruderProducts &&
    (lineCrossingLockedAsThirdWhenTwoOn ||
      (!productConflictRecoveryMode &&
        (lineCrossingBlockedByIntruder || lineCrossingBlockedByMotionPlus)));

  const motionPlusDisabledTooltip = allowConcurrentLineCrossingIntruderProducts
    ? `Intruder and Motion Plus can not run together. To enable Motion Plus, please toggle off Intruder.`
    : motionPlusLockedAsThirdWhenTwoOn
    ? `Intruder and Line Crossing are enabled. Turn one off before enabling Motion Plus.`
    : motionPlusBlockedByIntruder && motionPlusBlockedByLineCrossing
    ? `Motion Plus can not be run with either Intruder or Line Crossing enabled. To enable Motion Plus, please toggle off both Intruder and Line Crossing.`
    : motionPlusBlockedByIntruder
    ? `Intruder and Motion Plus can not run together. To enable Motion Plus, please toggle off Intruder.`
    : `Line Crossing and Motion Plus can not run together. To enable Motion Plus, please toggle off Line Crossing.`;

  const lineCrossingDisabledTooltip = lineCrossingLockedAsThirdWhenTwoOn
    ? `Intruder and Motion Plus are enabled. Turn one off before enabling Line Crossing.`
    : lineCrossingBlockedByIntruder && lineCrossingBlockedByMotionPlus
    ? `Line Crossing can not be run with either Intruder or Motion Plus enabled. To enable Line Crossing, please toggle off both Intruder and Motion Plus.`
    : lineCrossingBlockedByIntruder
    ? `Intruder and Line Crossing can not run together. To enable Line Crossing, please toggle off Intruder.`
    : `Motion Plus and Line Crossing can not run together. To enable Line Crossing, please toggle off Motion Plus.`;

  return (
    <div>
      {addHealthMonitoringDialogOpen && <AddHealthMonitoringDialog />}
      {!updatingSelectedGroups && (
        <div>
          <div
            className={"relative right-[1px] h-[38px] bg-white min-w-[1250px]"}
          >
            <div className="absolute right-[50px] top-[5px]">
              {!tabsOpen ? (
                <OrangeTextButton
                  onClick={() => {
                    const newTesterData = [...filteredProductsData];
                    newTesterData.forEach((object: any) => {
                      object.open = true;
                    });
                    setProductsData(newTesterData);
                    setLocalProductsData(newTesterData);
                    setAllTabsOpen(true);
                    setTabsOpen(true);
                  }}
                  text="Open All"
                  disabled={false}
                />
              ) : (
                <OrangeTextButton
                  onClick={() => {
                    const newTesterData = [...filteredProductsData];
                    newTesterData.forEach((object: any) => {
                      object.open = false;
                    });
                    setProductsData(newTesterData);
                    setLocalProductsData(newTesterData);
                    setAllTabsOpen(false);
                    setTabsOpen(false);
                  }}
                  text="Collapse All"
                  disabled={false}
                />
              )}
            </div>
          </div>
          {showHealthMonitoring && !isAutopatrolSite && (
            <div>
              <div
                className={
                  "relative right-[1px] h-[58px] bg-white min-w-[1250px]"
                }
              >
                <div className="absolute left-[20px]">
                  <Typography
                    variant="h6"
                    gutterBottom
                    component="div"
                    fontWeight="bold"
                    sx={{
                      fontFamily: "Mulish",
                      color: "#001943",
                      paddingTop: "10px",
                    }}
                  >
                    Health Monitoring
                  </Typography>
                </div>
                <div className="absolute left-[200px] top-[8px]">
                  <Switch
                    checked={chmActive}
                    color="warning"
                    disabled={false}
                    onChange={(event) => {
                      if (event.target.checked && !siteInfoEditCamera.chm) {
                        setChmActive(true);
                        setCHMValueChanged(true);
                        setAddHealthMonitoringDialogOpen(true);
                        const updatedChmStreamMetric = {
                          ...chmStreamMetric,
                          active: true,
                        };
                        setCHMStreamMetric(updatedChmStreamMetric);
                      }
                      if (event.target.checked && siteInfoEditCamera.chm) {
                        setChmActive(true);
                        const updatedChmStreamMetric = {
                          ...chmStreamMetric,
                          active: true,
                        };
                        setCHMStreamMetric(updatedChmStreamMetric);
                        setCHMValueChanged(true);
                      }
                      if (!event.target.checked) {
                        setChmActive(false);
                        const updatedChmStreamMetric = {
                          ...chmStreamMetric,
                          active: false,
                        };
                        setCHMStreamMetric(updatedChmStreamMetric);
                        setCHMValueChanged(true);
                      }
                    }}
                  />
                </div>
              </div>
            </div>
          )}
          {filteredProductsData.length !== 0 &&
            filteredProductsData.map(
              (productObject: any, productIndex: number) => {
                return (
                  <div
                    key={productObject.name}
                    className={productIndex === 0 ? "" : "pt-[1px]"}
                  >
                    <div
                      className={
                        "relative right-[1px] h-[58px] bg-white min-w-[1250px]"
                      }
                    >
                      <div className="absolute left-[20px]">
                        <Typography
                          variant="h6"
                          gutterBottom
                          component="div"
                          fontWeight="bold"
                          sx={{
                            fontFamily: "Mulish",
                            color: "#001943",
                            paddingTop: "10px",
                          }}
                        >
                          {productObject.name}
                        </Typography>
                      </div>
                      <div className="absolute left-[200px] top-[8px]">
                        {productObject.name !== "Intruder" &&
                          productObject.name !== "Intruder Plus" &&
                          productObject.name !== "Motion Plus" &&
                          productObject.name !== "Line Crossing" && (
                            <Switch
                              checked={
                                selectedGroups[productObject.label_name]
                                  .selected
                              }
                              color="warning"
                              disabled={false}
                              onChange={(event) => {
                                setSelectedGroups((previousState: any) => {
                                  const updatedState = { ...previousState };
                                  const updatedGroup =
                                    updatedState[productObject.label_name];
                                  for (const key in updatedGroup) {
                                    updatedGroup[key] = event.target.checked;
                                  }
                                  updatedState[productObject.label_name] =
                                    updatedGroup;
                                  return updatedState;
                                });
                                handleProductMasterSwitchEvent(
                                  setLocalProductsData,
                                  setProductsData,
                                  event,
                                  productObject
                                );
                                setGeneralInfoChangesMade(true);
                              }}
                            />
                          )}
                        {productObject.name === "Intruder" &&
                          createIntruderToggle(
                            selectedGroups,
                            setSelectedGroups,
                            setLocalProductsData,
                            setProductsData,
                            setGeneralInfoChangesMade,
                            productObject,
                            allowConcurrentLineCrossingIntruderProducts
                          )}
                        {productObject.name === "Intruder Plus" &&
                          (selectedGroups.intruderPlus.disabled ? (
                            <Tooltip
                              title={`Intruder is already enabled. To enable Intruder Plus, please toggle off Intruder.`}
                              placement="top"
                            >
                              <div>
                                <Switch
                                  checked={selectedGroups.intruderPlus.selected}
                                  color="warning"
                                  disabled={true}
                                />
                              </div>
                            </Tooltip>
                          ) : (
                            <Switch
                              checked={selectedGroups.intruderPlus.selected}
                              color="warning"
                              disabled={false}
                              onChange={(event) => {
                                if (!event.target.checked) {
                                  setSelectedGroups((previousState: any) => {
                                    return {
                                      ...previousState,
                                      intruder: {
                                        selected:
                                          previousState.intruder.selected,
                                        disabled:
                                          selectedGroups.intruder.selected,
                                        intruder:
                                          previousState.intruder.intruder,
                                        bike: previousState.intruder.bike,
                                        vehicle: previousState.intruder.vehicle,
                                      },
                                      intruderPlus: {
                                        selected: false,
                                        disabled:
                                          previousState.intruderPlus.disabled,
                                        intruder_plus: false,
                                        bike_plus: false,
                                        vehicle_plus: false,
                                      },
                                    };
                                  });
                                }
                                if (event.target.checked) {
                                  setSelectedGroups((previousState: any) => {
                                    return {
                                      ...previousState,
                                      intruder: {
                                        selected:
                                          previousState.intruder.selected,
                                        disabled:
                                          !selectedGroups.intruder.selected,
                                        intruder:
                                          previousState.intruder.intruder,
                                        bike: previousState.intruder.bike,
                                        vehicle: previousState.intruder.vehicle,
                                      },
                                      intruderPlus: {
                                        selected: true,
                                        disabled:
                                          previousState.intruderPlus.disabled,
                                        intruder_plus: true,
                                        bike_plus: true,
                                        vehicle_plus: true,
                                      },
                                    };
                                  });
                                }
                                handleProductMasterSwitchEvent(
                                  setLocalProductsData,
                                  setProductsData,
                                  event,
                                  productObject
                                );
                                setGeneralInfoChangesMade(true);
                              }}
                            />
                          ))}
                        {productObject.name === "Motion Plus" &&
                          (isMotionPlusToggleDisabled ? (
                            <Tooltip
                              title={motionPlusDisabledTooltip}
                              placement="top"
                            >
                              <div>
                                <Switch
                                  checked={selectedGroups.motionPlus.selected}
                                  color="warning"
                                  disabled={true}
                                />
                              </div>
                            </Tooltip>
                          ) : (
                            <Switch
                              checked={selectedGroups.motionPlus.selected}
                              color="warning"
                              disabled={false}
                              onChange={(event) => {
                                if (!event.target.checked) {
                                  setSelectedGroups((previousState: any) => {
                                    const intruderDisabledAfterMotionOff =
                                      previousState.intruderPlus.selected ||
                                      (!allowConcurrentLineCrossingIntruderProducts &&
                                        previousState.lineCrossing.selected);
                                    return {
                                      ...previousState,
                                      intruder: {
                                        selected:
                                          previousState.intruder.selected,
                                        disabled:
                                          intruderDisabledAfterMotionOff,
                                        intruder:
                                          previousState.intruder.intruder,
                                        bike: previousState.intruder.bike,
                                        vehicle: previousState.intruder.vehicle,
                                      },
                                      motionPlus: {
                                        selected: false,
                                        vehicle_motion: false,
                                        bike_motion: false,
                                        intruder_motion: false,
                                      },
                                    };
                                  });
                                }
                                if (event.target.checked) {
                                  setSelectedGroups((previousState: any) => {
                                    return {
                                      ...previousState,
                                      intruder: {
                                        selected:
                                          previousState.intruder.selected,
                                        disabled:
                                          selectedGroups.intruder.selected,
                                        intruder:
                                          previousState.intruder.intruder,
                                        bike: previousState.intruder.bike,
                                        vehicle: previousState.intruder.vehicle,
                                      },
                                      motionPlus: {
                                        selected: true,
                                        vehicle_motion: true,
                                        bike_motion: true,
                                        intruder_motion: true,
                                      },
                                    };
                                  });
                                }
                                handleProductMasterSwitchEvent(
                                  setLocalProductsData,
                                  setProductsData,
                                  event,
                                  productObject
                                );
                                setGeneralInfoChangesMade(true);
                              }}
                            />
                          ))}
                        {productObject.name === "Line Crossing" &&
                          (isLineCrossingToggleDisabled ? (
                            <Tooltip
                              title={lineCrossingDisabledTooltip}
                              placement="top"
                            >
                              <div>
                                <Switch
                                  checked={selectedGroups.lineCrossing.selected}
                                  color="warning"
                                  disabled={true}
                                />
                              </div>
                            </Tooltip>
                          ) : (
                            <Switch
                              checked={selectedGroups.lineCrossing.selected}
                              color="warning"
                              disabled={false}
                              onChange={(event) => {
                                setSelectedGroups((previousState: any) => {
                                  const updatedState = { ...previousState };
                                  const updatedGroup =
                                    updatedState.lineCrossing;
                                  for (const key in updatedGroup) {
                                    updatedGroup[key] = event.target.checked;
                                  }
                                  updatedState.lineCrossing = updatedGroup;
                                  return updatedState;
                                });
                                handleProductMasterSwitchEvent(
                                  setLocalProductsData,
                                  setProductsData,
                                  event,
                                  productObject
                                );
                                setGeneralInfoChangesMade(true);
                              }}
                            />
                          ))}
                      </div>
                      <div className="absolute right-[50px] top-[10px]">
                        {productObject.open ? (
                          <button>
                            <KeyboardArrowUpIcon
                              fontSize="large"
                              onClick={() => {
                                const newTesterData = [...filteredProductsData];
                                newTesterData[productIndex].open =
                                  !newTesterData[productIndex].open;
                                setProductsData(newTesterData);
                                setLocalProductsData(newTesterData);
                              }}
                            />
                          </button>
                        ) : (
                          <button>
                            <KeyboardArrowDownIcon
                              fontSize="large"
                              onClick={() => {
                                const newTesterData = [...filteredProductsData];
                                newTesterData[productIndex].open =
                                  !newTesterData[productIndex].open;
                                setProductsData(newTesterData);
                                setLocalProductsData(newTesterData);
                              }}
                            />
                          </button>
                        )}
                      </div>
                    </div>
                    {productObject.open && (
                      // create an outlined table that is padded with 10px inside the div
                      <div className="bg-white">
                        <div className="pt-[1px] pl-[40px] pr-[40px] pb-[10px]">
                          <TableContainer component={Paper}>
                            <Table
                              sx={{ fontFamily: "Mulish" }}
                              aria-label="simple table"
                            >
                              {productObject.name === "Crowd" &&
                                productObject.metrics.crowd
                                  .display_distance && (
                                  <TableHeadComponent
                                    titlesArray={[
                                      "METRIC",
                                      "ACTIVE",
                                      "SENSITIVITY",
                                      "MIN CROWD SIZE",
                                      "DISTANCE",
                                      ...doubleTakeHeader,
                                    ]}
                                  />
                                )}

                              {productObject.display_name === "Crowd" &&
                                !productObject.metrics.crowd
                                  .display_distance && (
                                  <TableHeadComponent
                                    titlesArray={[
                                      "METRIC",
                                      "ACTIVE",
                                      "SENSITIVITY",
                                      "MIN CROWD SIZE",
                                      "",
                                      ...doubleTakeHeader,
                                    ]}
                                  />
                                )}
                              {productObject.name === "Social Distancing" &&
                                productObject.metrics.social_distancing
                                  .display_distance && (
                                  <TableHeadComponent
                                    titlesArray={[
                                      "METRIC",
                                      "ACTIVE",
                                      "SENSITIVITY",
                                      "DISTANCE",
                                      "",
                                      ...doubleTakeHeader,
                                    ]}
                                  />
                                )}
                              {productObject.name === "Social Distancing" &&
                                !productObject.metrics.social_distancing
                                  .display_distance && (
                                  <TableHeadComponent
                                    titlesArray={[
                                      "METRIC",
                                      "ACTIVE",
                                      "SENSITIVITY",
                                      "",
                                      "",
                                      ...doubleTakeHeader,
                                    ]}
                                  />
                                )}
                              {
                                // productObject.name === "Left Object" ||
                                productObject.name === "Loitering" && (
                                  <TableHeadComponent
                                    titlesArray={[
                                      "METRIC",
                                      "ACTIVE",
                                      "SENSITIVITY",
                                      "LOITERING TIME",
                                      "",
                                      ...doubleTakeHeader,
                                    ]}
                                  />
                                )
                              }
                              {productObject.name !== "Crowd" &&
                                // productObject.name !== "Left Object" &&
                                productObject.name !== "Loitering" &&
                                productObject.name !== "Social Distancing" && (
                                  <TableHeadComponent
                                    titlesArray={[
                                      "METRIC",
                                      "ACTIVE",
                                      "SENSITIVITY",
                                      "",
                                      "",
                                      ...doubleTakeHeader,
                                    ]}
                                  />
                                )}
                              <TableBody>
                                {Object.entries(productObject.metrics).map(
                                  (
                                    [key, metricsObject]: [string, any],
                                    metricIndex: number
                                  ) => {
                                    const options = metricsObject.options;
                                    const optionsIds = new Map();
                                    const optionNames = new Map();
                                    const distanceOptions =
                                      metricsObject.distance_options;
                                    const distanceOptionsIds = new Map();
                                    const distanceOptionNames = new Map();
                                    if (metricsObject.options) {
                                      options.forEach((option: any) => {
                                        optionsIds.set(option[1], option[0]);
                                      });
                                      options.forEach((option: any) => {
                                        optionNames.set(option[0], option[1]);
                                      });
                                    }
                                    if (metricsObject.distance_options) {
                                      distanceOptions.forEach((option: any) => {
                                        distanceOptionsIds.set(
                                          option[1],
                                          option[0]
                                        );
                                      });
                                      distanceOptions.forEach((option: any) => {
                                        distanceOptionNames.set(
                                          option[0],
                                          option[1]
                                        );
                                      });
                                    }
                                    const isSubMetricSettingsDisabled =
                                      !metricsObject.active;
                                    return (
                                      <TableRow key={key}>
                                        <TableCell
                                          align="left"
                                          sx={{
                                            fontFamily: "Mulish",
                                            width: "200px",
                                            fontWeight: "bold",
                                          }}
                                        >
                                          {metricsObject.display_name}
                                        </TableCell>
                                        <TableCell
                                          align="left"
                                          sx={{
                                            fontFamily: "Mulish",
                                            width: "200px",
                                          }}
                                        >
                                          {switchCreator(
                                            metricsObject,
                                            selectedGroups,
                                            productObject.label_name,
                                            setSelectedGroups,
                                            setLocalProductsData,
                                            setProductsData,
                                            setGeneralInfoChangesMade,
                                            allowConcurrentLineCrossingIntruderProducts
                                          )}
                                        </TableCell>
                                        <TableCell
                                          align="left"
                                          sx={{
                                            fontFamily: "Mulish",
                                            width: "40px",
                                          }}
                                        >
                                          <div key={"thresh_option"}>
                                            <Autocomplete
                                              disablePortal
                                              disabled={
                                                isSubMetricSettingsDisabled
                                              }
                                              id={key}
                                              options={options.map(
                                                (option: string[]) => {
                                                  return option[0];
                                                }
                                              )}
                                              {...(useAutopatrolControlledSensitivity
                                                ? {
                                                    value:
                                                      metricsObject.option_id
                                                        ? optionsIds.get(
                                                            metricsObject.option_id
                                                          ) ?? null
                                                        : null,
                                                  }
                                                : {
                                                    defaultValue:
                                                      metricsObject.option_id
                                                        ? optionsIds.get(
                                                            metricsObject.option_id
                                                          )
                                                        : "",
                                                  })}
                                              onChange={(
                                                event: any,
                                                newInputValue: any
                                              ) => {
                                                handlePatchThresh(
                                                  newInputValue,
                                                  productObject.label_name,
                                                  metricsObject,
                                                  optionNames
                                                );
                                                setGeneralInfoChangesMade(true);
                                              }}
                                              sx={{ width: 250 }}
                                              renderInput={(params) => (
                                                <TextField
                                                  {...params}
                                                  variant="standard"
                                                  label="Thresh"
                                                  autoComplete="off"
                                                  id={key}
                                                  name={key}
                                                />
                                              )}
                                            />
                                          </div>
                                        </TableCell>
                                        {productObject.name ===
                                          "Social Distancing" &&
                                        productObject.metrics.social_distancing
                                          .display_distance ? (
                                          <TableCell
                                            align="left"
                                            sx={{
                                              fontFamily: "Mulish",
                                              width: "200px",
                                            }}
                                          >
                                            <div key={"distance_option"}>
                                              <Autocomplete
                                                disablePortal
                                                disabled={
                                                  isSubMetricSettingsDisabled
                                                }
                                                id={key}
                                                options={distanceOptions.map(
                                                  (option: string[]) => {
                                                    return option[0];
                                                  }
                                                )}
                                                defaultValue={
                                                  productObject.metrics
                                                    .social_distancing.distance
                                                    ? distanceOptionsIds.get(
                                                        productObject.metrics
                                                          .social_distancing
                                                          .distance
                                                      )
                                                    : ""
                                                }
                                                onChange={(
                                                  event: any,
                                                  newInputValue: any
                                                ) => {
                                                  handlePatchDistance(
                                                    newInputValue,
                                                    productObject.label_name,
                                                    metricsObject,
                                                    distanceOptionNames
                                                  );
                                                  setGeneralInfoChangesMade(
                                                    true
                                                  );
                                                }}
                                                sx={{ width: 250 }}
                                                renderInput={(params) => (
                                                  <TextField
                                                    {...params}
                                                    variant="standard"
                                                    label="Distance"
                                                    autoComplete="off"
                                                    id={key}
                                                    name={key}
                                                  />
                                                )}
                                              />
                                            </div>
                                          </TableCell>
                                        ) : metricsObject.user_input_label ? (
                                          <TableCell
                                            align="left"
                                            sx={{
                                              fontFamily: "Mulish",
                                              width: "200px",
                                            }}
                                          >
                                            <div>
                                              <TextField
                                                defaultValue={
                                                  metricsObject.user_input_value
                                                }
                                                autoComplete="off"
                                                variant="standard"
                                                disabled={
                                                  isSubMetricSettingsDisabled
                                                }
                                                onChange={(event: any) => {
                                                  handleExtraFieldInput(
                                                    event.target.value,
                                                    productObject.label_name,
                                                    metricsObject
                                                  );
                                                  setGeneralInfoChangesMade(
                                                    true
                                                  );
                                                }}
                                                sx={{ width: 150 }}
                                              />
                                            </div>
                                          </TableCell>
                                        ) : (
                                          <TableCell
                                            align="left"
                                            sx={{
                                              fontFamily: "Mulish",
                                              width: "200px",
                                            }}
                                          ></TableCell>
                                        )}
                                        {productObject.name === "Crowd" &&
                                        productObject.metrics.crowd
                                          .display_distance ? (
                                          <TableCell
                                            align="left"
                                            sx={{
                                              fontFamily: "Mulish",
                                              width: "200px",
                                            }}
                                          >
                                            <div key={"distance_option"}>
                                              <Autocomplete
                                                disablePortal
                                                disabled={
                                                  isSubMetricSettingsDisabled
                                                }
                                                id={key}
                                                options={distanceOptions.map(
                                                  (option: string[]) => {
                                                    return option[0];
                                                  }
                                                )}
                                                defaultValue={
                                                  productObject.metrics.crowd
                                                    .distance
                                                    ? distanceOptionsIds.get(
                                                        productObject.metrics
                                                          .crowd.distance
                                                      )
                                                    : ""
                                                }
                                                onChange={(
                                                  event: any,
                                                  newInputValue: any
                                                ) => {
                                                  handlePatchDistance(
                                                    newInputValue,
                                                    productObject.label_name,
                                                    metricsObject,
                                                    distanceOptionNames
                                                  );
                                                  setGeneralInfoChangesMade(
                                                    true
                                                  );
                                                }}
                                                sx={{ width: 250 }}
                                                renderInput={(params) => (
                                                  <TextField
                                                    {...params}
                                                    variant="standard"
                                                    label="Distance"
                                                    autoComplete="off"
                                                    id={key}
                                                    name={key}
                                                  />
                                                )}
                                              />
                                            </div>
                                          </TableCell>
                                        ) : (
                                          <TableCell
                                            align="left"
                                            sx={{
                                              fontFamily: "Mulish",
                                              width: "200px",
                                            }}
                                          ></TableCell>
                                        )}
                                        {showDoubleTake && (
                                          <TableCell
                                            align="left"
                                            sx={{
                                              fontFamily: "Mulish",
                                              width: "200px",
                                            }}
                                          >
                                            <Tooltip
                                              title={
                                                getDoubleTakeDisabledReason(
                                                  metricsObject
                                                ) ?? ""
                                              }
                                            >
                                              <span>
                                                <Switch
                                                  checked={Boolean(
                                                    metricsObject.vlm_enabled
                                                  )}
                                                  color="warning"
                                                  disabled={
                                                    getDoubleTakeDisabledReason(
                                                      metricsObject
                                                    ) !== null
                                                  }
                                                  inputProps={{
                                                    "aria-label": `DoubleTake ${metricsObject.display_name}`,
                                                  }}
                                                  onChange={(
                                                    event: React.ChangeEvent<HTMLInputElement>
                                                  ) => {
                                                    handleToggleDoubleTake(
                                                      productObject.label_name,
                                                      metricsObject.label_name,
                                                      event.target.checked
                                                    );
                                                  }}
                                                />
                                              </span>
                                            </Tooltip>
                                          </TableCell>
                                        )}
                                      </TableRow>
                                    );
                                  }
                                )}
                              </TableBody>
                            </Table>
                          </TableContainer>
                        </div>
                      </div>
                    )}
                  </div>
                );
              }
            )}
        </div>
      )}
    </div>
  );
};
